import { render, staticRenderFns } from "./ScanInstruction.vue?vue&type=template&id=3ecd2d71&scoped=true&lang=pug&"
import script from "./ScanInstruction.vue?vue&type=script&lang=js&"
export * from "./ScanInstruction.vue?vue&type=script&lang=js&"
import style0 from "./ScanInstruction.vue?vue&type=style&index=0&id=3ecd2d71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecd2d71",
  null
  
)

export default component.exports